import { z } from 'zod';

export const FranchiseSalesOrganizationFormSchema = z.object({
  current_working_brands: z.string().min(1, {
    message: "Current Working Brands can't be empty",
  }),
  have_any_fsos: z.string().min(1, {
    message: "Have Any FSOs can't be empty",
  }),
  detailed_answer: z.string().optional().nullable(),
});
